module.exports = __webpack_public_path__ + "static/Zyrafa_v2-b61fe3fd6945d34ee32f8a10cd8909f3.png";